/* eslint-disable no-console */
export const ACCESS_TOKEN_KEY = 'access_token';

const getAccessToken = () => {
  try {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
  } catch (error) {
    console.warn('Failed to access sessionStorage:', error);
    return null;
  }
};

const setAccessToken = (accessToken) => {
  try {
    // Validate token format before storing
    if (!accessToken || typeof accessToken !== 'string') {
      throw new Error('Invalid token format');
    }

    // Check if sessionStorage is available
    if (typeof Storage === 'undefined') {
      throw new Error('SessionStorage not supported');
    }

    sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  } catch (error) {
    if (error.name === 'QuotaExceededError') {
      console.warn('SessionStorage quota exceeded');
    } else {
      console.warn('Failed to store token:', error);
    }
  }
};

const removeAccessToken = () => {
  try {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  } catch (error) {
    console.warn('Failed to remove token:', error);
  }
};

export default {
  getAccessToken,
  setAccessToken,
  removeAccessToken,
};
